import PaymentContainerClient from "../../PaymentContainerClient";
import { PaymentMethodName } from "../../PaymentContainerClient/commons/enums";
import CreatePaymentRequestDto from "../../PaymentContainerClient/dtos/CreatePaymentRequestDto";
import CreatePaymentResponseDto from "../../PaymentContainerClient/dtos/CreatePaymentResponseDto";
import { GainsightEvent, trackEvent } from "../common/gainsight";

export const createPayment = async (
    token: string,
    locale: string,
    paymentPlanId: string,
    installmentIds: string[],
    paymentMethod: PaymentMethodName,
    scheduled: boolean = false
): Promise<CreatePaymentResponseDto> => {
    const paymentContainerClient = new PaymentContainerClient();

    const createPaymentRequestDto: CreatePaymentRequestDto = {
        installmentIds: installmentIds,
        paymentMethodName: paymentMethod,
        paymentPlanId: paymentPlanId,
        langLocale: locale,
        scheduled: scheduled,
    };

    const paymentData = await paymentContainerClient.createPayment(
        token,
        createPaymentRequestDto
    );

    trackEvent(GainsightEvent.CreatePayment, { scheduled: scheduled });

    return paymentData;
};
